import React from 'react';
import { ErrorInformation } from "components/ErrorInformation";
import { Button } from 'primereact/button';
import { Link } from "react-router-dom";

export function NotFoundPage () {
  return (
    <div className='pt-8'>
      <ErrorInformation
        title="Looks like you are lost"
        icon='😱'
        keepDefaultDescription={false}
        description={[
          "This page does not exist",
          <div className='text-xl'>
            <strong>
              <div> <span className='text-red-500'>Roses are red,</span> <span className='text-blue-500'> violets are blue </span> </div>
              <div className='text-indigo-700'> I'm going home, and so should you </div>
            </strong>
          </div>
        ]}
        actions={
          <Link
            className="no-underline"
            to='/'
            referrerPolicy="same-origin"
          >
            <Button
              label="Go Home"
              icon="pi pi-home"
              className='p-button-text p-button-lg'
            />
          </Link>
        }
      />
    </div>
  );
}
